import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import theme from './utils/theme';
import store from './redux/store';
import App from './App';
import './index.css';
import * as FullStory from '@fullstory/browser';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

FullStory.init(
  {
    orgId: 'o-1CZ4ZR-na1',
    recordCrossDomainIFrames: true,
    devMode: process.env.NODE_ENV !== 'production',
  },
  ({ sessionUrl }) => console.log(`Started session: ${sessionUrl}`)
);

root.render(
  <Provider store={store}>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </HelmetProvider>
  </Provider>
);

reportWebVitals();
serviceWorkerRegistration.register();
